export default "__VITE_ASSET__621f2519__"